import axios from './axios';

export const getMarketingKecambah = (
  params: any = null,
  next_page_url: string = null,
) => {
  if (next_page_url) return axios.get(`${next_page_url}&${params}`);
  return axios.get(`/enums/marketing?${params}`);
};

export const getAllPesanan = () => {
  return axios.get(`/admin/pesanan`);
};

export const getDetailPesanan = (pesanan_id: string) => {
  return axios.get(`/admin/pesanan/${pesanan_id}`);
};

export const getPesananByKategori = (
  kategori: string,
  page: number = 1,
  filter: any = null,
) => {
  if (filter)
    return axios.get(`/admin/pesanan/kategori/${kategori}?page=${page}&${filter}`);
  return axios.get(`/admin/pesanan/kategori/${kategori}?page=${page}`);
};

export const getOrderInsight = () => {
  return axios.get('/admin/pesanan/insight');
};
